import classnames from 'classnames';

import {
	useSelect,
} from '@wordpress/data';

import { useRef, useEffect, useMemo } from '@wordpress/element';

import { getEmbedClassNames } from '../../../blocks/utils';

function Save( props ) {
	const {
		background,
	} = props;

	const {
		backgroundColor = '#fffa',
		backgroundGradient = '',
		backgroundType = 'color',
		backgroundImage = {},
		backgroundFocalPoint = { x: 0.5, y: 0.5 },
		backgroundVideoFocalPoint = { x: 0.5, y: 0.5 },
		backgroundImageSize = 'cover',
		backgroundVideoSize = 'cover',
		backgroundVideo = {},
		backgroundVideoLoop = true,
		backgroundVideoMuted = true,
		backgroundOverlayImage = '',
		backgroundOverlayVideo = '',
		backgroundOverlayOpacity = 50,
	} = background;

	const backgroundStyle = () => {
		const ret = {
			opacity: 1,
		};

		if ( backgroundType === 'color' ||
			backgroundOverlayImage === 'color' ||
			backgroundOverlayVideo === 'color'
		) {
			ret.background = backgroundColor;
		} else if ( backgroundType === 'gradient' ||
			backgroundOverlayImage === 'gradient' ||
			backgroundOverlayVideo === 'gradient'
		) {
			ret.background = backgroundGradient;
		}

		if ( backgroundOverlayImage === 'color' ||
			backgroundOverlayImage === 'gradient' ||
			backgroundOverlayVideo === 'color' ||
			backgroundOverlayVideo === 'gradient'
		) {
			ret.opacity = `${ backgroundOverlayOpacity / 100 }`;
		}

		return ret;
	};

	const imageStyle = {
		objectFit: backgroundImageSize,
		objectPosition: `${ backgroundFocalPoint.x * 100 }% ${ backgroundFocalPoint.y * 100 }%`,
	};

	const videoStyle = {
		objectFit: backgroundVideoSize,
		objectPosition: `${ backgroundVideoFocalPoint.x * 100 }% ${ backgroundVideoFocalPoint.y * 100 }%`,
	};

	const hasNoMediaBackground = () => backgroundType !== 'image' && backgroundType !== 'video';
	const hasEmbedBackground = () => backgroundType === 'video' && backgroundVideo.url && backgroundVideo.embed && backgroundVideo.embedData;

	let embedClassnames = '';
	if ( backgroundType === 'video' && backgroundVideo.embedData ) {
		embedClassnames = getEmbedClassNames( backgroundVideo.embedData.html );
	}

	const classes = classnames( {
		'eedee-background-div': true,
		'no-media-background': hasNoMediaBackground(),
	}, embedClassnames );

	return (
		<div className={ classes }>
			{ (
				( backgroundType === 'image' ) ||
				( backgroundType === 'color' && backgroundOverlayImage === 'color' ) ||
				( backgroundType === 'gradient' && backgroundOverlayImage === 'gradient' )
			) &&
				backgroundImage.url &&
				<img
					className={ `wp-image-${ backgroundImage.id } swiper-zoom-target` }
					src={ backgroundImage.url }
					alt={ backgroundImage.alt }
					style={ imageStyle }
				/>
			}
			{ (
				( backgroundType === 'video' && ! backgroundVideo.embed ) ||
				( backgroundType === 'color' && backgroundOverlayVideo === 'color' ) ||
				( backgroundType === 'gradient' && backgroundOverlayVideo === 'gradient' )
			) &&
				backgroundVideo.url &&
				<video
					className="swiper-zoom-target"
					src={ backgroundVideo.url }
					autoPlay={ true }
					playsInline={ true }
					loop={ backgroundVideoLoop }
					muted={ backgroundVideoMuted }
					poster={ backgroundImage && backgroundImage.url }
					style={ videoStyle }
				/>
			}
			{ (
				( backgroundType === 'video' && backgroundVideo.embed ) ||
				( backgroundType === 'color' && backgroundOverlayVideo === 'color' ) ||
				( backgroundType === 'gradient' && backgroundOverlayVideo === 'gradient' )
			) &&
				backgroundVideo.url && backgroundVideo.embed && backgroundVideo.embedData &&
				<div
					className="wp-block-embed__wrapper"
					dangerouslySetInnerHTML={ { __html: backgroundVideo.embedData.html } }
				/>
			}
			<div className="eedee-background-div__overlay" style={ backgroundStyle() } />
		</div>
	);
}

function BackgroundDiv( props ) {
	return Save( props );
}

BackgroundDiv.Save = Save;
export default BackgroundDiv;
